import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from './reducers/category.reducer';
import authReducer from './reducers/auth.reducer';
import fitQuizButtonReducer from './reducers/fit.quiz.button.reducer';
import shopsReducer from './reducers/shops.reducer';
import newShopReducer from './reducers/shops.reducer';
import fitQuizWidgetReducer from './reducers/fit.quiz.widget.reducer';
import translationsReducer from './reducers/translations.reducer';
import domainReducer from './reducers/domain.reducer';
import couponReducer from './reducers/coupon.reducer';
import billingReducer from './reducers/billing.reducer';
import dashboardFeatureReducer from './reducers/dashboard.feature.reducer';
import advancedSettingsReducer from './reducers/advanced.settings.reducer';
import availableFeaturesReducer from './reducers/available.features.reducer';
import onboardingReducer from './reducers/onboarding.reducer';

export const store = configureStore({
  reducer: {
    fitButtonReducer: fitQuizButtonReducer,
    shopsReducer,
    authReducer,
    newShopReducer,
    widgetReducer: fitQuizWidgetReducer,
    translationsReducer,
    domainReducer,
    couponReducer,
    billingReducer,
    dashboardFeatureReducer,
    advancedSettingsReducer,
    availableFeaturesReducer,
    categoryReducer,
    onboardingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
